import "./App.css";
import Index from "./pages/Index";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import RecipesOverview from "./pages/RecipesOverview";
import Error from "./pages/Error";
import RecipeDetail from "./pages/RecipeDetail";
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";
import { useEffect, useState } from "react";

function App() {
  const [isSidenavOpen, setIsSidenavOpen] = useState(false);

  const toggleSidenav = () => {
    setIsSidenavOpen(!isSidenavOpen);
  };

  useEffect(() => {
    if (isSidenavOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidenavOpen]);

  return (
    <BrowserRouter>
      <NavBar isSidenavOpen={isSidenavOpen} toggleSidenav={toggleSidenav} />
      {isSidenavOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10 lg:hidden"
          onClick={toggleSidenav}
        ></div>
      )}
      <div className={`${isSidenavOpen ? "pointer-events-none" : ""}`}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/recipes" element={<RecipesOverview />} />
          <Route path="/recipes/:id" element={<RecipeDetail />} />
          <Route path="*" element={<Error />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
